
  /* eslint-disable */
  import { createApp } from 'vue'
  import App from './App.vue'
  import router from "@/router";
  import vueHelmet from "vue-helmet/src/VueHelmet";
  import * as VueGoogleMaps from "vue3-google-map";
  import { i18nState, t as i18nT, setLang as i18nSetLang } from "@/api/i18n";
  import brand, { initBrand } from "@/brand";


  document.title = "Hospital Management System";

  // Fire brand fetch in parallel with app boot — components read from the
  // reactive `brand` object and re-render once the API resolves.
  initBrand();

  const app = createApp(App);
  app.config.globalProperties.$brand = brand;

  // Global i18n: every component can call {{ $t('key','fallback') }} and
  // access `$i18n` (the reactive state) without per-file wiring.
  app.config.globalProperties.$t = (key, fallback) => i18nT(key, fallback);
  app.config.globalProperties.$i18n = i18nState;
  app.config.globalProperties.$setLang = i18nSetLang;

  app.use(VueGoogleMaps,{ load: {key: "AIzaSyAGPbYfcYqdbSBeXdIpH5iWrznfU886Qk8"}})
  app.use(router)
  app.use(vueHelmet)

  app.mount("#app");

  // ===== Idle auto-logout (security) =====
  // Logs the user out after a period of inactivity when signed in.
  // Configurable via localStorage "hms_idle_minutes" (default 60 — DHA SEC-AUTH-001
  // requires an idle timeout to exist; QA flagged short timeouts as too disruptive on wards).
  (function setupIdleLogout() {
    function idleMs() {
      var m = parseInt(localStorage.getItem("hms_idle_minutes") || "60", 10);
      if (isNaN(m) || m < 1) m = 60;
      return m * 60 * 1000;
    }
    var timer = null;
    function isSignedIn() {
      return !!(sessionStorage.getItem("isLoggedIn") || localStorage.getItem("authToken"));
    }
    function onIdle() {
      if (!isSignedIn()) { reset(); return; }
      try {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userProfile");
        sessionStorage.removeItem("isLoggedIn");
      } catch (e) {}
      router.push({ path: "/login", query: { timeout: "1" } }).catch(function(){});
    }
    function reset() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(onIdle, idleMs());
    }
    ["click", "mousemove", "keydown", "touchstart", "scroll"].forEach(function (ev) {
      window.addEventListener(ev, reset, { passive: true });
    });
    reset();
  })();




